import { render, staticRenderFns } from "./rilibaoindex.vue?vue&type=template&id=e842837a&scoped=true&"
import script from "./rilibaoindex.vue?vue&type=script&lang=js&"
export * from "./rilibaoindex.vue?vue&type=script&lang=js&"
import style0 from "./rilibaoindex.vue?vue&type=style&index=0&id=e842837a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e842837a",
  null
  
)

export default component.exports